import { AppButton } from 'components';
import CoursesSearch from 'components/molecules/CoursesSearch';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import { memo, useState } from 'react';
import ESTDropDownType1 from 'components/molecules/ESTDropDownType1';
import ESDropDown from 'components/molecules/ESDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import ChapterSearch from 'components/molecules/ChapterSearch';

function MoreFilters(props) {
  const { isOpen, closeModal, handleSearch } = props;

  const [courseInfo, setCourseInfo] = useState(Object.assign({}, initialState));
  const [courses, setCourses] = useState([]);
  const [chapters, setChapters] = useState([]);

  function clearArray() {
    setCourses([]);
    setChapters([]);
  }

  function handleInfoChange(data = {}) {
    setCourseInfo((x) => ({ ...x, ...data }));
    clearArray();
  }

  return (
    <AppModal open={isOpen} closeModal={closeModal} size="md">
      <AppModalHeader>More filters</AppModalHeader>
      <AppModalBody>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESTDropDownType1
              enableAPI
              value={courseInfo.estObj?._id}
              handleChange={(event, estObj) => {
                setCourseInfo((x) => ({ ...initialState, estObj }));
                clearArray();
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESDropDown
              enableAPI={courseInfo.estObj?._id ? true : false}
              dependencies={{
                query: courseInfo.estObj ? `est=${courseInfo.estObj._id}` : ``,
              }}
              value={courseInfo.esObj?._id}
              handleChange={(event, esObj) => {
                handleInfoChange({ esObj, classObj: null });
              }}
              defaultLook={false}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESClassDropDown
              enableAPI={courseInfo.esObj?._id ? true : false}
              dependencies={{
                query: `esId=${courseInfo.esObj?._id}`,
              }}
              value={courseInfo.classObj?._id}
              handleChange={(event, classObj) => {
                handleInfoChange({ classObj });
              }}
              defaultLook={false}
            />
          </div>
        </div>

        <CoursesSearch
          enableAPI
          dependencies={{
            query: {
              allCourses: false,
              esId: courseInfo.esObj?._id,
              estId: courseInfo.estObj?._id,
              classId: courseInfo.classObj?._id,
            },
          }}
          values={courses}
          handleChange={(data = []) => {
            setCourses(data);
          }}
        />

        <section className="mt-4">
          <ChapterSearch
            enableAPI={courses.length > 0}
            dependencies={{
              query: {
                esId: courseInfo.esObj?._id,
                estId: courseInfo.estObj?._id,
                classId: courseInfo.classObj?._id || 'all',
              },
              classID: courseInfo.classObj?._id || 'all',
              courseID: courses[0]?._id,
            }}
            values={chapters}
            handleChange={(data) => {
              setChapters(data);
            }}
          />
        </section>
      </AppModalBody>
      <AppModalFooter>
        <div className="d-flex flex-row mt-4 justify-content-center">
          <AppButton
            type="button"
            variantClass="btn-primary mx-3"
            style={{ minWidth: '1.5rem' }}
            onClick={() => {
              if (!courseInfo.classObj?._id) {
                window.alert('Please pick a class!');
                return;
              }
              if (!courses[0]?._id) {
                window.alert('Please pick a course!');
                return;
              }

              const apiBodyIds = {
                es: courseInfo.esObj?._id,
                est: courseInfo.estObj?._id,
                classId: courseInfo.classObj?._id,
                courseId: courses[0]?._id,
                chapterId: chapters[0]?._id,
              };
              const apiFilters = [
                { _id: courseInfo.estObj?._id, name: courseInfo.estObj?.name },
                { _id: courseInfo.esObj?._id, name: courseInfo.esObj?.name },
                { _id: courseInfo.classObj?._id, name: courseInfo.classObj?.name },
                { _id: courses[0]?._id, name: courses[0]?.courseName },
                { _id: chapters[0]?._id, name: chapters[0]?.name },
              ].filter((x) => x.name);

              handleSearch(apiFilters, apiBodyIds);
              closeModal();
            }}
          >
            Search
          </AppButton>
        </div>
      </AppModalFooter>
    </AppModal>
  );
}

const initialState = {
  classObj: null,
  estObj: null,
  esObj: null,
};

export default memo(MoreFilters);
